<template>
    <div>
        <v-container max-width="1500" style="max-width: 1500px !important">
            <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 2rem !important;">
                <v-system-bar class="py-5 px-3 system-bar-title" style="color: #fff" dark>
                    Seguimiento
                    <v-tooltip bottom color="success">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="green" v-bind="attrs" v-on="on" dark @click="generatePDF"
                                style="margin: 1rem 0;height: 1.9rem;">
                                <v-icon color="white" style="font-size: 1.5rem;">mdi-download-box</v-icon>
                            </v-btn>
                        </template>
                        <span>Descargar</span>
                    </v-tooltip>
                </v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 2rem !important;">
                <v-row style="padding: 1rem;">
                    <v-col cols="12" sm="12" md="4" lg="3">
                        <v-autocomplete max-width="200" class="mx-3" v-model="pacienteSelect" label="Paciente"
                            prepend-icon="mdi-magnify" :items="dataExplota" item-text="paciente"
                            item-value="autogenerado" outlined dense></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="2">
                        <v-autocomplete max-width="200" class="mx-3" v-model="pacienteSelect" label="DNI"
                            prepend-icon="mdi-magnify" :items="dataExplota" item-text="dni_paciente"
                            item-value="autogenerado" outlined dense></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="2">
                        <v-autocomplete max-width="200" class="mx-3" v-model="pacienteSelect" label="Autogenerado"
                            prepend-icon="mdi-magnify" :items="dataExplota" item-text="autogenerado"
                            item-value="autogenerado" outlined dense></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="3" lg="2">
                        <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="date" label="Periodo" prepend-icon="mdi-calendar" outlined dense
                                    readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="date" type="month" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="modal = false">
                                    Cancel
                                </v-btn>
                                <v-btn text color="primary" @click="saveDate">
                                    OK
                                </v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="12" md="1" lg="1"
                        style="padding: 0 1.5rem 0 0 !important;display:flex;justify-content: end;">
                        <v-tooltip bottom color="info">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" dark class="mb-2"
                                    style="margin: .9rem 0 .7rem 1.5rem;background: #1780cd;" @click="search">
                                    <v-icon style="font-size: 1.8rem;">
                                        mdi-card-search
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Buscar</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-card>
            <div style="display: flex; flex-wrap: wrap;">
                <v-card v-if="viewGraficos" class="mx-auto my-5"
                    style=" margin:0 auto;width:30rem; padding: 1rem;height: 100%;">
                    <div>
                        <canvas width="300" height="400" ref="chart1"></canvas>
                    </div>
                </v-card>
                <v-card v-if="viewGraficos" class="mx-auto my-5"
                    style=" margin:0 auto;width:30rem; padding: 1rem;height: 100%;">
                    <div>
                        <canvas width="300" height="400" ref="chart2"></canvas>
                    </div>
                </v-card>
                <v-card v-if="viewGraficos" class="mx-auto my-5"
                    style=" margin:0 auto;width:30rem; padding: 1rem;height: 100%;">
                    <div>
                        <canvas width="300" height="400" ref="chart3"></canvas>
                    </div>
                </v-card>
                <v-card v-if="viewGraficos" class="mx-auto my-5"
                    style=" margin:0 auto;width:35rem; padding: 1rem;height: 100%;">
                    <div>
                        <canvas width="300" height="400" ref="chart4"></canvas>
                    </div>
                </v-card>
                <v-card v-if="viewGraficos" class="mx-auto my-5"
                    style=" margin:0 auto;width:35rem; padding: 1rem;height: 100%;">
                    <div>
                        <canvas width="300" height="400" ref="chart5"></canvas>
                    </div>
                </v-card>
            </div>
            <v-dialog v-model="dialogLoader" persistent width="300"
                style="padding: 1rem;overflow: hidden !important;background: white !important;">
                <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
            </v-dialog>
        </v-container>
    </div>
</template>
<style scoped>
::v-deep .v-dialog {
    display: flex;
    justify-content: center;
    box-shadow: none;
    overflow-y: hidden !important;
}

.system-bar-title {
    display: flex;
    justify-content: space-between;
    color: white;
    padding: 1.2rem 1.4rem !important;
}

.add-column {
    position: absolute;
    left: -10%;
    height: 1.2rem;
    width: 1.2rem;
    bottom: -85%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.3s ease;
}

.minus-column {
    position: absolute;
    left: -10%;
    height: 1.2rem;
    width: 1.2rem;
    bottom: -85%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.3s ease;
}

::v-deep .table-style table tr:hover .add-column {
    display: flex !important;
    cursor: pointer;
}

::v-deep .table-style table tr:hover .minus-column {
    display: flex !important;
    cursor: pointer;
}

.popup-window {
    width: 20rem;
    position: absolute;
    background-color: white;
    border: 1px solid #ccc;
    padding: 1rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

::v-deep .v-text-field.v-input--dense:not(.v-text-field--outlined) input {
    text-align: center !important;
}

::v-deep tr th {
    text-wrap: nowrap !important;
}

::v-deep tr td {
    text-wrap: nowrap !important;
}

::v-deep .v-card {
    box-shadow: 0px 0px 11px 6px rgb(15 61 99 / 27%) !important;
}

::v-deep .v-btn {
    text-transform: capitalize !important;
}

::v-deep .theme--dark.v-system-bar {
    background: #1780cd;
    color: white;
    font-size: 600;
}

.custom-btn {
    width: 32px !important;
    height: 32px !important;
}

.custom-icon {
    font-size: 20px !important;
}

.bg-primary-table {
    /* background: rgb(27 160 255 / 12%); */
    font-weight: 400;
}

.text-start {
    font-size: 0.8rem !important;
}

.container {
    max-width: 3000px !important;
}

td {
    white-space: nowrap;
}

::v-deep .highlight-column {
    background-color: #f0f0f0 !important;
    /* Color de fondo para las columnas visibles */
    transition: background-color 0.3s ease;
    /* Añade una transición suave */
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Chart from "chart.js";
import Swal from "sweetalert2";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
export default {
    data() {
        return {
            viewGraficos: false,
            stateLife1: false,
            pacienteSelect: null,
            dialogForm: false,
            statusEdit: true,
            statusViewColumnHB: false,
            popupVisible: false,
            hoveredItem: null,
            popupStyles: {
                top: '-8000px',
                left: '0px'
            },
            dialogHistograma: false,
            date: new Date().toISOString().slice(0, 7),
            modal: false,
            searchSubactividad: null,
            searchDNI: [],
            dialogLoader: false,
            dataPaciente: [],
            sortBy: [{ key: "cupos_disponible", order: "asc" }],
            headers: [
                { text: "MES", value: "MES", sortable: false },
                { text: "AÑO", value: "ANO", sortable: false },
                { text: "CAPRE", value: "CAPRE", align: "center", sortable: false },
                { text: "PPRE", value: "PPRE", align: "center", sortable: false },
                { text: "TRUPRE", value: "TRUPRE", align: "center", sortable: false },
                { text: "CREAPRE", value: "CREAPRE", align: "center", sortable: false },
                { text: "PTH", value: "PTH", align: "center", sortable: false }//Ingresar dato
            ],
            dialogEdit: false,
            dialogDelete: false,
            isLoading: false,
            itemsTipSex: ["MASCULINO", "FEMENINO"],
            menu: false,
            selectedColumns: ['MES', 'ANO', 'CAPRE', 'PPRE', 'TRUPRE', 'PTH'],
            itemMes: null,
            itemPeriodo: null,
            statusViewColumn: false,
            dataArray: [],
            dataExplota: [],
            chart: null,
            chartData1: [],
            chart2: null,
            chartData2: [],
            chart3: null,
            chartData3: [],
            chart4: null,
            chartData4: [],
            chart5: null,
            chartData5: [],
            title1: "Hemoglobina",
            title2: "Dosis EPO",
            title3: "Calcio",
            title4: "Fósforo",
            title5: "Paratohormona",
            labelColum1: [],
            labelColum2: [],
            labelColum3: [],
            labelColum4: [],
            labelColum5: [],
            pacienteDatos:[],
            dateHoy:new Date().toISOString().slice(0, 10),
        };
    },
    methods: {
        renderChart1(canvas, data, label, type = "line") {
            if (this.chart) {
                this.chart.destroy();  // Destruir gráfico anterior
            }
            this.chart = new Chart(canvas, {
                type: type,
                data: {
                    labels: this.labelColum1,
                    datasets: [
                        {
                            label: label,
                            data: data,
                            backgroundColor: [
                                "rgba(75, 192, 192, 0.2)",
                                "rgba(54, 162, 235, 0.2)",
                                "rgba(255, 206, 86, 0.2)",
                                "rgba(75, 192, 192, 0.2)",
                            ],
                            borderColor: [
                                "rgba(75, 192, 192, 1)",
                                "rgba(54, 162, 235, 1)",
                                "rgba(255, 206, 86, 1)",
                                "rgba(75, 192, 192, 1)",
                            ],
                            borderWidth: 1,
                            fill: false
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        tooltip: {
                            enabled: true,
                        },
                    },
                    elements: {
                        point: {
                            pointStyle: 'circle',
                            radius: 5,
                        },
                    },
                    animation: false, // Desactiva la animación para evitar problemas al renderizar texto
                    scales: {
                        x: {
                            beginAtZero: true
                        },
                        y: {
                            beginAtZero: true
                        }
                    },
                },
                plugins: [{
                    // Usa afterDraw para dibujar los valores sobre los puntos
                    afterDraw: (chart) => {
                        const ctx = chart.ctx;
                        chart.data.datasets.forEach((dataset, datasetIndex) => {
                            const meta = chart.getDatasetMeta(datasetIndex);
                            meta.data.forEach((point, index) => {
                                const value = dataset.data[index];
                                ctx.fillStyle = 'rgba(0, 0, 0, 0.6)'; // Color del texto
                                ctx.font = 'bold 12px Arial'; // Estilo del texto
                                ctx.textAlign = 'center';
                                ctx.textBaseline = 'bottom';
                                ctx.fillText(value, point.x, point.y - 5); // Posición del texto
                            });
                        });
                    }
                }]
            });

        },
        renderChart2(canvas, data, label, type = "line") {
            if (this.chart2) {
                this.chart2.destroy();  // Destruir gráfico anterior
            }
            this.chart2 = new Chart(canvas, {
                type: type,
                data: {
                    labels: this.labelColum2,
                    datasets: [
                        {
                            label: label,
                            data: data,
                            backgroundColor: [
                                "rgba(75, 192, 192, 0.2)",
                                "rgba(54, 162, 235, 0.2)",
                                "rgba(255, 206, 86, 0.2)",
                                "rgba(75, 192, 192, 0.2)",
                            ],
                            borderColor: [
                                "rgba(75, 192, 192, 1)",
                                "rgba(54, 162, 235, 1)",
                                "rgba(255, 206, 86, 1)",
                                "rgba(75, 192, 192, 1)",
                            ],
                            borderWidth: 1,
                            fill: false
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        tooltip: {
                            enabled: true,
                        },
                    },
                    elements: {
                        point: {
                            pointStyle: 'circle',
                            radius: 5,
                        },
                    },
                    animation: false, // Desactiva la animación para evitar problemas al renderizar texto
                    scales: {
                        x: {
                            beginAtZero: true
                        },
                        y: {
                            beginAtZero: true
                        }
                    },
                },
                plugins: [{
                    // Usa afterDraw para dibujar los valores sobre los puntos
                    afterDraw: (chart) => {
                        const ctx = chart.ctx;
                        chart.data.datasets.forEach((dataset, datasetIndex) => {
                            const meta = chart.getDatasetMeta(datasetIndex);
                            meta.data.forEach((point, index) => {
                                const value = dataset.data[index];
                                ctx.fillStyle = 'rgba(0, 0, 0, 0.6)'; // Color del texto
                                ctx.font = 'bold 12px Arial'; // Estilo del texto
                                ctx.textAlign = 'center';
                                ctx.textBaseline = 'bottom';
                                ctx.fillText(value, point.x, point.y - 5); // Posición del texto
                            });
                        });
                    }
                }]
            });

        },
        renderChart3(canvas, data, label, type = "line") {
            if (this.chart3) {
                this.chart3.destroy();  // Destruir gráfico anterior
            }
            this.chart3 = new Chart(canvas, {
                type: type,
                data: {
                    labels: this.labelColum3,
                    datasets: [
                        {
                            label: label,
                            data: data,
                            backgroundColor: [
                                "rgba(75, 192, 192, 0.2)",
                                "rgba(54, 162, 235, 0.2)",
                                "rgba(255, 206, 86, 0.2)",
                                "rgba(75, 192, 192, 0.2)",
                            ],
                            borderColor: [
                                "rgba(75, 192, 192, 1)",
                                "rgba(54, 162, 235, 1)",
                                "rgba(255, 206, 86, 1)",
                                "rgba(75, 192, 192, 1)",
                            ],
                            borderWidth: 1,
                            fill: false
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        tooltip: {
                            enabled: true,
                        },
                    },
                    elements: {
                        point: {
                            pointStyle: 'circle',
                            radius: 5,
                        },
                    },
                    animation: false, // Desactiva la animación para evitar problemas al renderizar texto
                    scales: {
                        x: {
                            beginAtZero: true
                        },
                        y: {
                            beginAtZero: true
                        }
                    },
                },
                plugins: [{
                    // Usa afterDraw para dibujar los valores sobre los puntos
                    afterDraw: (chart) => {
                        const ctx = chart.ctx;
                        chart.data.datasets.forEach((dataset, datasetIndex) => {
                            const meta = chart.getDatasetMeta(datasetIndex);
                            meta.data.forEach((point, index) => {
                                const value = dataset.data[index];
                                ctx.fillStyle = 'rgba(0, 0, 0, 0.6)'; // Color del texto
                                ctx.font = 'bold 12px Arial'; // Estilo del texto
                                ctx.textAlign = 'center';
                                ctx.textBaseline = 'bottom';
                                ctx.fillText(value, point.x, point.y - 5); // Posición del texto
                            });
                        });
                    }
                }]
            });

        },
        renderChart4(canvas, data, label, type = "line") {
            if (this.chart4) {
                this.chart4.destroy();  // Destruir gráfico anterior
            }
            this.chart4 = new Chart(canvas, {
                type: type,
                data: {
                    labels: this.labelColum4,
                    datasets: [
                        {
                            label: label,
                            data: data,
                            backgroundColor: [
                                "rgba(75, 192, 192, 0.2)",
                                "rgba(54, 162, 235, 0.2)",
                                "rgba(255, 206, 86, 0.2)",
                                "rgba(75, 192, 192, 0.2)",
                            ],
                            borderColor: [
                                "rgba(75, 192, 192, 1)",
                                "rgba(54, 162, 235, 1)",
                                "rgba(255, 206, 86, 1)",
                                "rgba(75, 192, 192, 1)",
                            ],
                            borderWidth: 1,
                            fill: false
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        tooltip: {
                            enabled: true,
                        },
                    },
                    elements: {
                        point: {
                            pointStyle: 'circle',
                            radius: 5,
                        },
                    },
                    animation: false, // Desactiva la animación para evitar problemas al renderizar texto
                    scales: {
                        x: {
                            beginAtZero: true
                        },
                        y: {
                            beginAtZero: true
                        }
                    },
                },
                plugins: [{
                    // Usa afterDraw para dibujar los valores sobre los puntos
                    afterDraw: (chart) => {
                        const ctx = chart.ctx;
                        chart.data.datasets.forEach((dataset, datasetIndex) => {
                            const meta = chart.getDatasetMeta(datasetIndex);
                            meta.data.forEach((point, index) => {
                                const value = dataset.data[index];
                                ctx.fillStyle = 'rgba(0, 0, 0, 0.6)'; // Color del texto
                                ctx.font = 'bold 12px Arial'; // Estilo del texto
                                ctx.textAlign = 'center';
                                ctx.textBaseline = 'bottom';
                                ctx.fillText(value, point.x, point.y - 5); // Posición del texto
                            });
                        });
                    }
                }]
            });

        },
        renderChart5(canvas, data, label, type = "line") {
            if (this.chart5) {
                this.chart5.destroy();  // Destruir gráfico anterior
            }
            this.chart5 = new Chart(canvas, {
                type: type,
                data: {
                    labels: this.labelColum5,
                    datasets: [
                        {
                            label: label,
                            data: data,
                            backgroundColor: [
                                "rgba(75, 192, 192, 0.2)",
                                "rgba(54, 162, 235, 0.2)",
                                "rgba(255, 206, 86, 0.2)",
                                "rgba(75, 192, 192, 0.2)",
                            ],
                            borderColor: [
                                "rgba(75, 192, 192, 1)",
                                "rgba(54, 162, 235, 1)",
                                "rgba(255, 206, 86, 1)",
                                "rgba(75, 192, 192, 1)",
                            ],
                            borderWidth: 1,
                            fill: false
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        tooltip: {
                            enabled: true,
                        },
                    },
                    elements: {
                        point: {
                            pointStyle: 'circle',
                            radius: 5,
                        },
                    },
                    animation: false, // Desactiva la animación para evitar problemas al renderizar texto
                    scales: {
                        x: {
                            beginAtZero: true
                        },
                        y: {
                            beginAtZero: true
                        }
                    },
                },
                plugins: [{
                    // Usa afterDraw para dibujar los valores sobre los puntos
                    afterDraw: (chart) => {
                        const ctx = chart.ctx;
                        chart.data.datasets.forEach((dataset, datasetIndex) => {
                            const meta = chart.getDatasetMeta(datasetIndex);
                            meta.data.forEach((point, index) => {
                                const value = dataset.data[index];
                                ctx.fillStyle = 'rgba(0, 0, 0, 0.6)'; // Color del texto
                                ctx.font = 'bold 12px Arial'; // Estilo del texto
                                ctx.textAlign = 'center';
                                ctx.textBaseline = 'bottom';
                                ctx.fillText(value, point.x, point.y - 5); // Posición del texto
                            });
                        });
                    }
                }]
            });

        },
        saveDate() {
            // Ejecuta la lógica adicional
            this.loadPeriodo();
            // Luego ejecuta la función de guardado del diálogo
            this.$refs.dialog.save(this.date);
        },
        loadPeriodo() {
            let [year, month] = this.date.split('-');
            this.itemMes = month;
            this.itemPeriodo = year;
            this.listarPacientes();
        },
        listarPacientes() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_lista_pacientes_laboratorio/", { periodo: this.date }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dialogLoader = false;
                            this.dataExplota = res.data;

                        })
                        .catch((res) => {
                            this.dialogLoader = false;
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    this.dialogLoader = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        search() {
            this.selectPaciente();
            this.graficoHemoglobina();
            this.graficoDosisEPO();
            this.graficoCalcio();
            this.graficoFosforo();
            this.graficoParatoHor();
        },
        graficoHemoglobina() {
            this.viewGraficos = true;
            this.dialogLoader = true;
            this.isLoading = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_reporte_laboratorio_protocolo_hemoglobina/", { autogenerado: this.pacienteSelect, fecha: this.date }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.isLoading = false;
                            const data = res.data;
                            this.chartData1 = [];
                            this.labelColum1 = [];
                            for (let i = 0; i < data.length; i++) {
                                const element = data[i];
                                this.chartData1.push(element.VALOR);
                                this.labelColum1.push(element.FECHA_RESULTADO);
                            }
                            this.renderChart1(this.$refs.chart1, this.chartData1, this.title1);
                            this.dialogLoader = false;
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                            this.dialogLoader = false;
                        });
                })
                .catch((response) => {
                    this.dialogLoader = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        graficoDosisEPO() {
            this.dialogLoader = true;
            this.isLoading = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_reporte_laboratorio_protocolo_dosis_epo/", { autogenerado: this.pacienteSelect, fecha: this.date }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.isLoading = false;
                            const data = res.data;
                            this.chartData2 = [];
                            this.labelColum2 = [];
                            for (let i = 0; i < data.length; i++) {
                                const element = data[i];
                                this.chartData2.push(element.VALOR);
                                this.labelColum2.push(element.FECHA_RESULTADO);
                            }
                            this.renderChart2(this.$refs.chart2, this.chartData2, this.title2);
                            this.dialogLoader = false;
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                            this.dialogLoader = false;
                        });
                })
                .catch((response) => {
                    this.dialogLoader = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        graficoCalcio() {
            this.dialogLoader = true;
            this.isLoading = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_reporte_laboratorio_protocolo_calcio/", { autogenerado: this.pacienteSelect, fecha: this.date }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.isLoading = false;
                            const data = res.data;
                            this.chartData3 = [];
                            this.labelColum3 = [];
                            for (let i = 0; i < data.length; i++) {
                                const element = data[i];
                                this.chartData3.push(element.VALOR);
                                this.labelColum3.push(element.FECHA_RESULTADO);
                            }
                            this.renderChart3(this.$refs.chart3, this.chartData3, this.title3);
                            this.dialogLoader = false;
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                            this.dialogLoader = false;
                        });
                })
                .catch((response) => {
                    this.dialogLoader = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        graficoFosforo() {
            this.dialogLoader = true;
            this.isLoading = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_reporte_laboratorio_protocolo_fosforo/", { autogenerado: this.pacienteSelect, fecha: this.date }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.isLoading = false;
                            const data = res.data;
                            this.chartData4 = [];
                            this.labelColum4 = [];
                            for (let i = 0; i < data.length; i++) {
                                const element = data[i];
                                this.chartData4.push(element.VALOR);
                                this.labelColum4.push(element.FECHA_RESULTADO);
                            }
                            this.renderChart4(this.$refs.chart4, this.chartData4, this.title4);
                            this.dialogLoader = false;
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                            this.dialogLoader = false;
                        });
                })
                .catch((response) => {
                    this.dialogLoader = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        graficoParatoHor() {
            this.dialogLoader = true;
            this.isLoading = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_reporte_laboratorio_protocolo_paratohormona/", { autogenerado: this.pacienteSelect, fecha: this.date }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.isLoading = false;
                            const data = res.data;
                            this.chartData5 = [];
                            this.labelColum5 = [];
                            for (let i = 0; i < data.length; i++) {
                                const element = data[i];
                                this.chartData5.push(element.VALOR);
                                this.labelColum5.push(element.FECHA_RESULTADO);
                            }
                            this.renderChart5(this.$refs.chart5, this.chartData5, this.title5);
                            this.dialogLoader = false;
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                            this.dialogLoader = false;
                        });
                })
                .catch((response) => {
                    this.dialogLoader = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        selectPaciente(){
            let filteredData = this.dataExplota.filter(item => item.autogenerado === this.pacienteSelect);
            this.pacienteDatos=filteredData[0];
            
        },
        generatePDF() {
            this.dialogLoader = true;
            const doc = new jsPDF('p', 'mm', 'a4');

            // Añadir título y logos
            doc.setFontSize(16);
            doc.text('Resultados de paciente', 105, 20, { align: 'center' });

            // Subrayar el texto (línea debajo del título)
            /* const textWidth = doc.getTextWidth('RESULTADOS DE PACIENTE');
            doc.line(105 - (textWidth / 2), 22, 105 + (textWidth / 2), 22); */

            doc.addImage('https://upload.wikimedia.org/wikipedia/commons/5/56/Logo_EsSalud.png', 'PNG', 10, 5, 40, 20);  // Logo izquierdo
            doc.addImage('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSZPNrIDN5kEEFk0FwSGAv1Pqy3ptIyMWNCEQ&s', 'PNG', 160, 5, 40, 20);// 
            // Agregar información del paciente
            doc.setFontSize(10);
            // Columna izquierda
            doc.text(`DNI: ${this.pacienteDatos.dni_paciente}`, 15, 40);
            doc.text(`Nombres: ${this.pacienteDatos.paciente}`, 15, 45);

            // Columna derecha
            doc.text(`Autogenerado: ${this.pacienteSelect}`, 110, 40); // Mueve la posición x a 105mm
            doc.text(`Fecha: ${this.dateHoy}`, 110, 45);

            // Captura y agrega los gráficos
            const chartPromises = [
                this.captureChart(this.$refs.chart1),
                this.captureChart(this.$refs.chart2),
                this.captureChart(this.$refs.chart3),
                this.captureChart(this.$refs.chart4),
                this.captureChart(this.$refs.chart5),
            ];

            // Añadir los gráficos al PDF en una sola página
            Promise.all(chartPromises).then((images) => {
                let x = 15, y = 55, width = 80, height = 70;

                images.forEach((image, index) => {
                    // Posicionar los gráficos en 3 filas de 2 gráficos
                    if (index % 2 === 0 && index !== 0) {
                        y += height + 10; // Mueve hacia abajo después de cada fila de 2 gráficos
                        x = 15; // Reinicia la posición x
                    }
                    doc.addImage(image, 'PNG', x, y, width, height);
                    x += width + 15; // Mueve a la derecha después de cada gráfico
                });

                // Descargar el PDF
                doc.save('informe_paciente.pdf');
                this.dialogLoader = false;
            });
        },
        captureChart(canvas) {
            return html2canvas(canvas).then((canvas) => {
                return canvas.toDataURL('image/png');
            });
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
    },
    computed: {
        filteredHeaders() {
            return this.headers.filter(header => this.selectedColumns.includes(header.value));
        },
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
        filteredData() {
            if (!this.searchSubactividad && this.searchDNI.length == 0) {
                return this.dataExplota;
            }
            let filtered = this.dataExplota;
            if (this.searchSubactividad) {
                filtered = filtered.filter((item) => {
                    const nombreCompleto = item.paciente;
                    return nombreCompleto.toLowerCase().includes(this.searchSubactividad.toLowerCase());
                });
            }
            if (this.searchDNI.length !== 0) {
                filtered = filtered.filter((item) =>
                    item.AUTOGENERADO
                        .toLowerCase()
                        .includes(this.searchDNI)
                );
            }
            return filtered;
        },
    },
    created() {
        this.loadPeriodo();
        this.listarPacientes();
    },
    components: {
        /*   Histograma,
          Form */
    },
};
</script>